var _path;

import * as React from "react";

function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.032 6.476c8.699 0 15.714 5.565 15.714 12.397S28.731 31.27 20.032 31.27c-1.99 0-3.962-.3-5.863-.898a2.23 2.23 0 00-1.978.305c-1.556 1.145-4.123 2.486-7.233 2.794.781-1.065 2.095-2.853 2.87-4.904l.008-.024c.302-.794.126-1.627-.453-2.312-2.037-2.21-3.125-4.71-3.125-7.358 0-6.832 7.082-12.397 15.774-12.397zm0-2.254c-9.953 0-18.03 6.558-18.03 14.65 0 3.356 1.403 6.428 3.727 8.89-1.048 2.782-3.231 5.133-3.266 5.16a1.696 1.696 0 00-.326 1.83 1.704 1.704 0 001.553 1.026c4.332 0 7.685-1.814 9.798-3.258a21.933 21.933 0 006.544 1.004c9.96 0 17.968-6.56 17.968-14.651 0-8.091-8.009-14.65-17.968-14.65z"
  })));
}

export default SvgComment;